import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormsModule } from '@angular/forms';
import { first } from 'rxjs/operators';

//import { UserService } from '../../services/user.service';
import { CommonDataService } from '../../services/common-data.service';
import { CommerceDataService } from '../../services/commerce-data.service';
import { environment } from '../../../environments/environment';

declare var $:any;
declare var iziToast:any;

@Component({
  selector: 'app-account-wishlist-page',
  templateUrl: './account-wishlist-page.component.html',
  styleUrls: ['./account-wishlist-page.component.css']
})
export class AccountWishlistPageComponent implements OnInit {
  
  pageName = "My Wishlist";

  wishList = []
  products = []
  items = 0
  ready

  p: number = 1;
  itemsPerPage = 5;
  userId
  
  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private _data: CommonDataService,
    private _ecomm: CommerceDataService
  ) { }

  ngOnInit() {
   $('#initialise-page').trigger('click');

   this.userId = sessionStorage.getItem('context')
   if( this.userId) {
     //if yes get a wishlist from the API 
        this.getWishList(this.userId)
    }
  }

  getWishList(userId) {

    $('#loader').show();
    let modelObject1 = new FormData();

     modelObject1.append('modelName', 'WishList');
     modelObject1.append('context_id', userId);

      // $('#loader').show();
      //lets get the model for this page
      this._data.getModelData(modelObject1) 
      .pipe(first())
      .subscribe(
        data => {
          if(data['covers'].length > 0) {
            let wishlistString = data['covers'][0]['cover']['model']['modelData']['formFieldsEntities']['wishlist']['products'];
            // let wishlist = wishlistString.split(",")
            this.getWishListProducts(wishlistString)
          }
          
        },
        error => {

            $('#loader').hide();

        },

        () => {
          $('#loader').hide();
          // this.reviewOrderSummary()
        }
      );
      
    
  }

  goShopping() {
    this.router.navigate(['/shop/products']);
  }

  clearWishList() {

  }

  removeFromWishlist(prodId, i) {
    this._ecomm.getUserWishlistAndAppendNewItem(prodId)

    this.products.splice(i, 1)
  }

  getWishListProducts(wishlistProducts) {
    let queryData = new FormData();
    queryData.append('modelName', "Product");
    queryData.append('mids', wishlistProducts);

      
      //lets get the model for this page
      this._data.getModelDataShopModels(queryData) 
      .pipe(first())
      .subscribe(
        data => {

          this.products = data['covers'];
          this.items = this.products.length
          this.ready = true

        },
        error => {

        $('#loader').hide();

        },

        () => {
            $('#loader').hide();
        }
      );
  }

  getProductImageSrc(modelData){

    if( modelData['files'] && modelData['files']['uploads'] && Array.isArray(modelData['files']['uploads']) && modelData['files']['uploads'].length > 0) {
      let productImages = modelData['files']['uploads']

      for (let index = 0; index < productImages.length; index++) {
        let element = productImages[index];

        if(element['tmp_name'] && element['tmp_name'] != '') {
          let srcStrings = element['tmp_name'].split("public/");
          let src = environment.filesSrc+'/'+srcStrings[1]
          element['src'] = src
          return src
        }
        
      }

    }

      return ''
  }

}
